import { CONVERSION_TYPES } from '@shared/constants/overview/ConversionsTypesConstant';
import ADS_PLATFORMS from '@shared/constants/AdsPlatformsConstants';

export const SYMBOLS_TO_REMOVE = ['_', '.'];

export const COST_PREFIX = 'cost_per_';

export const DEFAULT_AVAILABLE_CONVERSIONS = Object.values(CONVERSION_TYPES);

export const TEXTS = {
    SELECT_LABEL: 'Conversion Types',
};

export const PLATFORMS_WITH_CONVERSION_TYPES = [
    ADS_PLATFORMS.FACEBOOK_ADS,
    ADS_PLATFORMS.CLIENT,
];

export const APPCUES_ID = {
    CONVERSION_TYPES_SELECT: 'CONVERSION_TYPES_SELECT',
};
